import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { AppShell } from './app/components/AppShell'
import { RequireSession } from './app/components/RequireSession'
import { PageSkeleton } from './app/components/ui/Skeleton'
import { LoginPage } from './app/pages/LoginPage'
import { StorefrontPage } from './app/pages/StorefrontPage'
import { useKitchenStore } from './app/kitchenStore'

const AccountPages = lazy(() =>
  import('./app/pages/AccountPages').then((module) => ({
    default: module.OrdersPage,
  })),
)
const PlansAccountPage = lazy(() =>
  import('./app/pages/AccountPages').then((module) => ({
    default: module.PlansPage,
  })),
)
const ProfilePage = lazy(() =>
  import('./app/pages/AccountPages').then((module) => ({
    default: module.ProfilePage,
  })),
)
const BasketPage = lazy(() =>
  import('./app/pages/BasketPage').then((module) => ({
    default: module.BasketPage,
  })),
)
const CheckoutPage = lazy(() =>
  import('./app/pages/CheckoutPage').then((module) => ({
    default: module.CheckoutPage,
  })),
)
const ConfirmationPage = lazy(() =>
  import('./app/pages/ConfirmationPage').then((module) => ({
    default: module.ConfirmationPage,
  })),
)
const PlanPage = lazy(() =>
  import('./app/pages/PlanPage').then((module) => ({
    default: module.PlanPage,
  })),
)
const ProductPage = lazy(() =>
  import('./app/pages/ProductPage').then((module) => ({
    default: module.ProductPage,
  })),
)

function KitchenHomeRedirect() {
  const slug = useKitchenStore((state) => state.slug)
  return <Navigate to={`/k/${slug}`} replace />
}

export default function App() {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<AppShell />}>
          <Route index element={<KitchenHomeRedirect />} />
          <Route path="/k/:slug" element={<StorefrontPage />} />
          <Route
            path="/k/:slug/s/:serviceDate/:serviceKey"
            element={<StorefrontPage />}
          />
          <Route path="/k/:slug/items/:itemId" element={<ProductPage />} />
          <Route
            path="/k/:slug/plans/:planId"
            element={
              <RequireSession>
                <PlanPage />
              </RequireSession>
            }
          />
          <Route path="/basket" element={<BasketPage />} />
          <Route
            path="/checkout"
            element={
              <RequireSession>
                <CheckoutPage />
              </RequireSession>
            }
          />
          <Route
            path="/orders/:orderId/confirmed"
            element={
              <RequireSession>
                <ConfirmationPage />
              </RequireSession>
            }
          />
          <Route
            path="/orders"
            element={
              <RequireSession>
                <AccountPages />
              </RequireSession>
            }
          />
          <Route
            path="/plans"
            element={
              <RequireSession>
                <PlansAccountPage />
              </RequireSession>
            }
          />
          <Route
            path="/profile"
            element={
              <RequireSession>
                <ProfilePage />
              </RequireSession>
            }
          />
          <Route path="*" element={<KitchenHomeRedirect />} />
        </Route>
      </Routes>
    </Suspense>
  )
}
